import React from 'react';
import SectionContainer from '../../common/SectionContainer';
import FieldRow from '../../common/FieldRow';
import { r22 as r22Fn } from '../formulas';
import { LINEAS_INGRESOS, LINEAS_EGRESOS } from '../../../../../services/dj1947/calculo';

const R22Section = ({ data }) => (
  <SectionContainer title="Recuadro N° 22" subtitle="Base Imponible Régimen de Transparencia Tributaria (Art. 14 letra D) N° 8 LIR) — según DJ 1947">
    <div className="f22-subsection">
      <h4 className="f22-subsection-title">Ingresos</h4>
      {LINEAS_INGRESOS.map(({ codigo, titulo }) => (
        <FieldRow key={codigo} label={titulo} code={codigo} sign="(+)" value={r22Fn.linea(data, codigo)} computed />
      ))}
      <FieldRow label="Total de ingresos anuales" code="1610" sign="(=)" value={r22Fn.totalIngresos(data)} computed className="f22-field-subtotal" />
    </div>
    <div className="f22-subsection">
      <h4 className="f22-subsection-title">Egresos</h4>
      {LINEAS_EGRESOS.map(({ codigo, titulo }) => (
        <FieldRow key={codigo} label={titulo} code={codigo} sign="(-)" value={r22Fn.linea(data, codigo)} computed />
      ))}
      <FieldRow label="Total de egresos anuales" code="1629" sign="(=)" value={r22Fn.totalEgresos(data)} computed className="f22-field-subtotal" />
    </div>
    <div className="f22-subsection">
      <FieldRow label="Base imponible a asignar a propietarios que son contribuyentes de impuestos finales, o pérdida tributaria del ejercicio" code="1630" sign="(=)" value={r22Fn.baseImponible(data)} computed className="f22-field-total" />
    </div>
  </SectionContainer>
);

export default R22Section;
